module.exports = __webpack_public_path__ + "prod/1.42.2/img/system-two.64a3af33.png";